export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/';
export const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8000/notification';
export default { API_URL };
